import { get } from 'svelte/store'
import { configStore, providerStore } from '@src/stores'
import { ethers } from '@credenza3/core-web-evm-ext'
import { TRUSTED_FORWARDER } from '@packages/utils/constants'
import { CHAIN_INFO } from '@packages/utils/chains'
import { forwardTransaction } from '@lib/ws/socket-io'

const isGaslessTxSupported = async (contract: ethers.Contract) => {
  try {
    const trustedForwarder = await contract.getTrustedForwarder()
    return trustedForwarder.toLowerCase() === TRUSTED_FORWARDER
  } catch (err) {
    console.warn('Gasless tx are not available for this contract', err?.message || err)
    return false
  }
}

export const sendContractTx = async (
  tx: ethers.ContractTransaction,
  contract: ethers.Contract,
): Promise<ethers.TransactionResponse> => {
  if (!(await isGaslessTxSupported(contract))) {
    const signer = await get(providerStore).getSigner()
    const response = await signer.sendTransaction(tx)
    return response
  }

  const { credenza, chainId } = get(configStore)
  tx.chainId = BigInt(chainId)
  const txBytes = ethers.Transaction.from(tx).unsignedSerialized

  return await forwardTransaction(credenza.evmApiUrl, txBytes)
}

export const getTxScanAddress = (txHash: string) => {
  const { chainId } = get(configStore)
  return CHAIN_INFO[chainId].scanUrl + '/tx/' + txHash
}
